import { flatten } from 'lodash'
import * as yup from 'yup'

import { arrayLength, stringRequired } from '../../util/customValidations'
import { isValidCnpj, isValidCpf } from '../../util/documentValidator'
import { documentTypes } from '../../util/enums'
import { getMessage } from '../../util/IntlMessages'

export const validationSchema = yup.object().shape({
  partnerName: yup.string().required(getMessage('mandatoryField')),
  documentTypeId: yup.number().required(getMessage('mandatoryField')),
  documentNumber: yup
    .string()
    .when(['documentTypeId', 'partnerName'], {
      is: (documentTypeId, partnerName) => documentTypeId && partnerName,
      then: (schema) =>
        schema.test({
          test: function (value) {
            const { documentTypeId } = this.parent
            const documentType = documentTypeId.toString()

            switch (documentType) {
              case documentTypes.CPF:
                return isValidCpf(value) || this.createError({ message: getMessage('cpfInvalid') })
              case documentTypes.CNPJ:
                return isValidCnpj(value) || this.createError({ message: getMessage('cnpjInvalid') })
              default:
                return false
            }
          }
        })
    })
    .required(getMessage('mandatoryField'))
})

export const FormValidations = (customFieldValidation) => {
  let reqCustomFields = {}
  const customFormFields = customFieldValidation.map(({ formFields }) => formFields)
  flatten(customFormFields).filter((item) => {
    if (item && item.requiredField) {
      let maxCaracters = null
      let minCaracters = null
      const { minValue, maxValue } = JSON.parse(item.fieldProperties)
      if (item.fieldTypes.internalTypeName !== 'upload') {
        maxCaracters = 255

        if (maxValue) {
          maxCaracters = maxValue
        }

        if (minValue) {
          minCaracters = minValue
        }
      }

      reqCustomFields = {
        ...reqCustomFields,
        [item.internalFieldName]: stringRequired(
          item.fieldName,
          maxCaracters,
          customFieldValidationType(item.fieldTypes.internalTypeName),
          minCaracters
        )
      }
    }
  })

  const config = {
    name: stringRequired('Nome', 60, 'shouldBeString'),
    documentNumber: yup
      .string()
      .when(['documentTypeId', 'name'], {
        is: (documentType, name) => documentType && name,
        then: () =>
          yup.string().test('document-validation', 'Número de documento inválido', function (value) {
            const { documentTypeId } = this.parent
            let isValid = false
            switch (documentTypeId) {
              case documentTypes.CPF:
                isValid = isValidCpf(value)
                if (!isValid) {
                  return this.createError({
                    message: 'CPF inválido',
                    path: this.path
                  })
                }
                break
              case documentTypes.CNPJ:
                isValid = isValidCnpj(value)
                if (!isValid) {
                  return this.createError({
                    message: 'CNPJ inválido',
                    path: this.path
                  })
                }
                break
            }
            if (isValid) {
              return true
            }
          })
      })
      .required('Número de documento precisa ser preenchido.'),
    documentTypeId: stringRequired('Tipo do documento', 20, 'shouldSelectAValue'),
    types: arrayLength()
    //  types: stringRequired('customerType', 255, 'shouldBeString'),
    //  'maps.long': numberNullAble('shouldBeNumber'),
    //  'maps.lat': numberNullAble('shouldBeNumber'),
    //  ...reqCustomFields,
    //  ...externalValidations
  }

  return yup.object().shape(config)
}

const customFieldValidationType = (field) => {
  const type = {
    inputText: 'shouldBeString',
    inputArea: 'shouldBeString',
    inputNumber: 'shouldBeNumber',
    select: 'shouldSelectAValue',
    date: 'shouldBeString',
    upload: 'shouldBeString'
  }

  return type[field]
}
